// src/App.js
import React from 'react';
import Base64Converter from './Base64Converter';
import './App.css'; // Importer le fichier CSS

function App() {
  return (
    <div className="App">
      <Base64Converter />
    </div>
  );
}

export default App;
